<template>
    <div class="social-lead-page">
        <!-- MOBILE VIEW -->
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <div class="main-container-mobile">
                <div class="first-container-mobile">
                    <div class="first-block-mobile">
                        <div class="logo-container-header-mobile">
                            <img src="@/assets/img/jameson-logo-age-confirm.png" alt="Jameson logo"
                                class="jameson-logo-mobile" />
                        </div>
                        <div class="banner-container-mobile">
                            <img src="@/assets/img/big-img-first-block.png" alt="Jameson"
                                class="big-img-first-block-mobile" />
                        </div>
                        <p class="title-first-block-mobile">
                            <span v-for="(line, i) in config.title" :key="i">
                                {{ line }}
                                <br v-if="i < config.title.length - 1">
                            </span>
                        </p>
                        <p class="description-first-block-mobile">
                            <span v-for="(line, i) in config.description" :key="i">
                                {{ line }}
                                <br v-if="i < config.description.length - 1">
                            </span>
                        </p>
                        <p class="description-first-block-small-mobile" v-if="config.smallDescrtiption">
                            <span v-for="(line, i) in config.smallDescrtiption" :key="i">
                                {{ line }}
                                <br v-if="i < config.smallDescrtiption.length - 1">
                            </span>
                        </p>
                    </div>
                </div>

                <div class="second-container second-container-mobile"
                    :style="{ '--bg-url': `url(${require('@/assets' + config.bgImageSecond)})` }">
                    <div class="second-first-container-mobile">
                        <div class="second-first-block-mobile">
                            <p class="second-block-title-mobile">{{ config.titleCond }}</p>
                            <p class="second-block-description-mobile">
                                <span>{{ config.secondTitleCond }}</span>
                            </p>
                        </div>
                        <div class="second-second-block-mobile">
                            <div v-for="(cond, index) in config.conditions" :key="index"
                                class="d-flex flex-row align-items-center condition-container-mobile">
                                <p class="number-mobile">{{ index + 1 }}.</p>
                                <p class="condition-text-mobile"><span v-html="cond"></span></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="third-container-mobile">
                    <img src="@/assets/img/jameson-form-bg-mobile-left.png" alt="Background"
                        class="background-image-mobile-topleft" />
                    <img src="@/assets/img/jameson-form-bg-mobile-right.png" alt="Background"
                        class="background-image-mobile-topright" />

                    <div class="registration-body-container-mobile">
                        <div class="title-container">
                            <p class="text-title-mobile">Зарегистрируйся!</p>
                        </div>
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#007749" />
                        </div>
                        <div v-else-if="formError" class="form-error">
                            <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                            <button class="btn-form-submit-mobile mt-6 mb-6" @click="getFormFields">Повторить попытку</button>
                        </div>
                        <div v-else class="form-main-mobile">
                            <div v-for="question in normalQuestions" :key="question.id" class="form-container-mobile">
                                <div>
                                    <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body-mobile"
                                        v-model="formData[question.id]" :placeholder="getPlaceholder(question, true)"
                                        @blur="markTouched(question)" @input="validateField(question)" />
                                    <input v-else-if="question.type === 4" class="input-body-mobile"
                                        v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                        placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                        @focus="onPhoneFocus(question)" @input="onPhoneInput(question)" />
                                    <div class="error-message" v-if="![5, 6, 9].includes(question.type)">
                                        <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                    </div>
                                </div>
                                <v-select v-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                    :items="question.answers" item-text="name" item-value="id" dense outlined
                                    hide-details :placeholder="getPlaceholder(question, true)" class="mb-3 pt-1">
                                    <template v-slot:selection="{ item }">
                                        <div v-if="item" style="white-space: normal; word-break: break-word;">
                                            {{ item.name }}
                                        </div>
                                        <span v-else class="truncate-text">
                                            {{ getPlaceholder(question, true) }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                            <div class="btn-container mt-4">
                                <div v-for="question in filteredQuestions" :key="question.id" class="checkbox-container-mobile">
                                    <div class="checkbox-content">
                                        <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                            :id="question.id" @change="markTouched(question)"
                                            @input="validateField(question)" />
                                        <label class="checkbox-label-mobile" :for="question.id">
                                            <template v-if="question.number === 8 || question.number === 9">
                                                Я даю согласие на
                                                <a class="policy-link" @click.stop.prevent="openPopup('offer')">
                                                    сбор и обработку персональных данных
                                                </a>
                                            </template>
                                            <template v-else>
                                                {{ question.name }}
                                            </template>
                                        </label>
                                    </div>
                                </div>
                                <button @click="confirmRegistration" class="btn-form-submit-mobile mt-6 mb-6"
                                    :disabled="isSendSms">
                                    {{ isSendSms ? "Отправка..." : "Зарегистрироваться" }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="main-container-footer-mobile">
                    <div class="footer-container-mobile">
                        <div class="politics-container-mobile">
                            <div class="logo-container-footer">
                                <img src="@/assets/img/jameson-logo-age-confirm.svg" alt="logo"
                                    class="jameson-logo-footer-mobile" />
                            </div>
                            <div class="d-flex flex-column-reverse">
                                <div class="footer-first-block">
                                    <p class="link-text-mobile pb-5">{{ config.footer.warningText }}</p>
                                    <a class="link-text-mobile" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <div class="logo-container-footer-2">
                                    <img src="@/assets/img/j-invicible.png" alt="logo" class="j-logo-footer-mobile" />
                                </div>
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text-mobile">
                                        <a class="footer-main-text-mobile" @click="openPopup(item.href)">{{ item.text }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="social-container-mobile">
                            <div class="social-icons-container">
                                <div @click="goTo('https://www.instagram.com/jamesonkz')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="#154734" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                        <path d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z"
                                            fill="#000000" />
                                        <path d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z" fill="#000000" />
                                        <path d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z" fill="#000000" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms"
                    @verifyCode="submitAnswersWithCode" @closePopup="showOtpPopup = false" :success="otpSuccess"
                    :errorMessage="otpError" :loading="otpVerifying" />
            </div>
        </div>

        <!-- DESKTOP VIEW -->
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <div class="main-container">
                <div class="first-container">
                    <div class="first-block">
                        <div class="logo-header-desktop">
                            <img src="@/assets/img/jameson-logo-age-confirm.png" alt="logo" class="jameson-logo" />
                            <img src="@/assets/img/j-invicible.png" alt="logo" class="jameson-invisible" />
                        </div>
                        <p class="title-first-block">
                            <span v-for="(line, i) in config.title" :key="i">
                                {{ line }}
                                <br v-if="i < config.title.length - 1">
                            </span>
                        </p>
                        <p class="description-first-block">
                            <span v-for="(line, i) in config.description" :key="i">
                                {{ line }}
                                <br v-if="i < config.description.length - 1">
                            </span>
                        </p>
                        <p class="description-first-block-small" v-if="config.smallDescrtiption">
                            <span v-for="(line, i) in config.smallDescrtiption" :key="i">
                                {{ line }}
                                <br v-if="i < config.smallDescrtiption.length - 1">
                            </span>
                        </p>
                    </div>
                    <div class="second-block">
                        <img src="@/assets/img/big-img-first-block.png" alt="Jameson" class="big-img-first-block" />
                    </div>
                </div>

                <div class="second-container"
                    :style="{ '--bg-url': `url(${require('@/assets' + config.bgImageSecond)})` }">
                    <div class="second-first-container">
                        <div class="second-first-block">
                            <p class="second-block-title">{{ config.titleCond }}</p>
                            <p class="second-block-description">
                                <span>{{ config.secondTitleCond }}</span>
                            </p>
                        </div>
                        <div class="second-second-block">
                            <div v-for="(cond, index) in config.conditions" :key="index"
                                class="condition-container">
                                <p class="number">{{ index + 1 }}.</p>
                                <p class="condition-text"><span v-html="cond"></span></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="third-container">
                    <img src="@/assets/img/jameson-form-bg-left.png" alt="Background" class="background-image-topleft" />
                    <img src="@/assets/img/jameson-form-bg-right.png" alt="Background" class="background-image-topright" />

                    <div class="registration-body-container">
                        <div class="title-container">
                            <p class="text-title">Зарегистрируйся!</p>
                        </div>
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#007749" />
                        </div>
                        <div v-else-if="formError" class="form-error">
                            <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                            <button class="btn-form-submit mt-8 mb-8" @click="getFormFields">Повторить попытку</button>
                        </div>
                        <div v-else class="form-main">
                            <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                                <div>
                                    <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body"
                                        v-model="formData[question.id]" :placeholder="getPlaceholder(question)"
                                        @blur="markTouched(question)" @input="validateField(question)" />
                                    <input v-else-if="question.type === 4" class="input-body"
                                        v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                        placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                        @focus="onPhoneFocus(question)" @input="onPhoneInput(question)" />
                                    <div class="error-message" v-if="![5, 6, 9].includes(question.type)">
                                        <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                    </div>
                                </div>
                                <v-select v-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                    :items="question.answers" item-text="name" item-value="id" dense outlined
                                    hide-details :placeholder="getPlaceholder(question)" class="my-select mb-4">
                                    <template v-slot:selection="{ item }">
                                        <div class="select-input" style="white-space: normal; word-break: break-word;">
                                            {{ item.name }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>

                        <div v-if="!formError" class="btn-container mt-6">
                            <div v-for="question in filteredQuestions" :key="question.id" class="checkbox-container">
                                <div class="checkbox-content">
                                    <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                        :id="question.id" @change="markTouched(question)"
                                        @input="validateField(question)" />
                                    <label class="checkbox-label" :for="question.id">
                                        <template v-if="question.number === 8 || question.number === 9">
                                            Я даю согласие на
                                            <a class="policy-link" @click.stop.prevent="openPopup('offer')">
                                                сбор и обработку персональных данных
                                            </a>
                                        </template>
                                        <template v-else>
                                            {{ question.name }}
                                        </template>
                                    </label>
                                </div>
                            </div>
                            <button @click="confirmRegistration" class="btn-form-submit mt-8 mb-10"
                                :disabled="isSendSms">
                                {{ isSendSms ? "Отправка..." : "Зарегистрироваться" }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="main-container-footer">
                    <div class="footer-container">
                        <div class="politics-container">
                            <div>
                                <img src="@/assets/img/jameson-logo-age-confirm.svg" alt="logo" class="jameson-logo-footer" />
                            </div>
                            <div class="d-flex mt-7">
                                <div class="footer-first-block">
                                    <p class="link-text pb-5">{{ config.footer.warningText }}</p>
                                    <a class="link-text" style="text-decoration: underline;"
                                        :href="config.footer.policyLink.href" target="_blank">
                                        {{ config.footer.policyLink.text }}
                                    </a>
                                </div>
                                <div class="footer-second-block">
                                    <p v-for="(item, index) in config.footer.menuLinks" :key="index"
                                        class="footer-main-text">
                                        <a class="footer-main-text" @click="openPopup(item.href)">{{ item.text }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="social-container">
                            <div class="footer-j-logo">
                                <img src="@/assets/img/j-invicible.png" alt="logo" class="j-logo-footer" />
                            </div>
                            <div class="social-icons-container">
                                <div @click="goTo('https://www.instagram.com/jamesonkz')">
                                    <svg width="51" height="51" viewBox="0 0 51 51" fill="#154734"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="25.8242" cy="25.8315" r="25" fill="#F2E4B5" />
                                        <path d="M36.3973 21.1698C36.3467 20.0215 36.161 19.232 35.895 18.548C35.6206 17.8218 35.1984 17.1717 34.6452 16.6313C34.1048 16.0825 33.4504 15.656 32.7327 15.3859C32.0447 15.1199 31.2593 14.9342 30.111 14.8835C28.9541 14.8286 28.5869 14.8159 25.6527 14.8159C22.7185 14.8159 22.3512 14.8286 21.1986 14.8792C20.0503 14.9299 19.2609 15.1157 18.5769 15.3816C17.8507 15.656 17.2006 16.0782 16.6601 16.6313C16.1113 17.1717 15.685 17.8261 15.4147 18.5439C15.1487 19.232 14.963 20.0172 14.9123 21.1655C14.8574 22.3224 14.8447 22.6897 14.8447 25.6239C14.8447 28.5581 14.8574 28.9253 14.9081 30.0779C14.9587 31.2263 15.1445 32.0157 15.4106 32.6998C15.685 33.4259 16.1113 34.076 16.6601 34.6164C17.2006 35.1653 17.8549 35.5918 18.5727 35.8619C19.2609 36.1279 20.046 36.3136 21.1945 36.3642C22.3469 36.415 22.7144 36.4276 25.6486 36.4276C28.5828 36.4276 28.95 36.415 30.1026 36.3642C31.2509 36.3136 32.0404 36.1279 32.7243 35.8619C34.1767 35.3003 35.325 34.152 35.8866 32.6998C36.1524 32.0116 36.3383 31.2263 36.3889 30.0779C36.4395 28.9253 36.4522 28.5581 36.4522 25.6239C36.4522 22.6897 36.4479 22.3224 36.3973 21.1698ZM34.4511 29.9935C34.4046 31.049 34.2273 31.6189 34.0796 31.9989C33.7164 32.9404 32.9692 33.6876 32.0277 34.0508C31.6477 34.1985 31.0736 34.3758 30.0223 34.4222C28.8824 34.473 28.5405 34.4855 25.657 34.4855C22.7734 34.4855 22.4272 34.473 21.2915 34.4222C20.236 34.3758 19.6661 34.1985 19.2861 34.0508C18.8176 33.8776 18.3911 33.6032 18.0449 33.2443C17.6861 32.8939 17.4116 32.4717 17.2385 32.0032C17.0907 31.6232 16.9134 31.049 16.8671 29.9978C16.8163 28.8579 16.8038 28.5159 16.8038 25.6323C16.8038 22.7487 16.8163 22.4026 16.8671 21.267C16.9134 20.2115 17.0907 19.6415 17.2385 19.2616C17.4116 18.7929 17.6861 18.3666 18.0492 18.0202C18.3995 17.6614 18.8217 17.387 19.2904 17.214C19.6703 17.0662 20.2446 16.8889 21.2958 16.8424C22.4357 16.7918 22.7777 16.7791 25.6611 16.7791C28.5489 16.7791 28.8908 16.7918 30.0266 16.8424C31.0821 16.8889 31.652 17.0662 32.032 17.214C32.5005 17.387 32.927 17.6614 33.2731 18.0202C33.632 18.3707 33.9064 18.7929 34.0796 19.2616C34.2273 19.6415 34.4046 20.2156 34.4511 21.267C34.5018 22.4069 34.5145 22.7487 34.5145 25.6323C34.5145 28.5159 34.5018 28.8536 34.4511 29.9935Z"
                                            fill="#000000" />
                                        <path d="M25.6543 20.0715C22.5893 20.0715 20.1025 22.5581 20.1025 25.6233C20.1025 28.6884 22.5893 31.175 25.6543 31.175C28.7194 31.175 31.206 28.6884 31.206 25.6233C31.206 22.5581 28.7194 20.0715 25.6543 20.0715ZM25.6543 29.2246C23.6659 29.2246 22.053 27.6118 22.053 25.6233C22.053 23.6347 23.6659 22.022 25.6543 22.022C27.6428 22.022 29.2556 23.6347 29.2556 25.6233C29.2556 27.6118 27.6428 29.2246 25.6543 29.2246Z" fill="#000000" />
                                        <path d="M32.7222 19.8522C32.7222 20.568 32.1419 21.1483 31.426 21.1483C30.7102 21.1483 30.1299 20.568 30.1299 19.8522C30.1299 19.1363 30.7102 18.5562 31.426 18.5562C32.1419 18.5562 32.7222 19.1363 32.7222 19.8522Z" fill="#000000" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms"
                    @verifyCode="submitAnswersWithCode" @closePopup="showOtpPopup = false" :success="otpSuccess"
                    :errorMessage="otpError" :loading="otpVerifying" />
            </div>
        </div>

        <ConfirmAge1 v-if="showConfirm" @confirmed="onConfirmed" />

        <transition name="popup">
            <div v-if="isPopupOpen" class="popup-overlay" @click.self="closePopup">
                <div class="popup-content">
                    <div class="popup-header">
                        <span class="header-text">{{ popupTexts[currentPopup] ? popupTexts[currentPopup].title : '' }}</span>
                        <span class="popup-close-1" @click="closePopup">
                            <svg width="21" height="21" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.07373 33.4784C-0.348236 34.8712 -0.377256 37.4247 1.10275 38.9046C2.58275 40.3845 5.13648 40.3264 6.52942 38.9336L19.9945 25.4697L33.4597 38.9046C34.9106 40.3555 37.4063 40.3845 38.8863 38.8756C40.3663 37.3957 40.3663 34.9003 38.9154 33.4494L25.4793 20.0145L38.9154 6.5506C40.3663 5.09975 40.3663 2.60428 38.8863 1.12441C37.4063 -0.384476 34.9106 -0.355459 33.4597 1.09539L19.9945 14.5303L6.52942 1.06638C5.13648 -0.326442 2.58275 -0.384476 1.10275 1.09539C-0.377256 2.57526 -0.348236 5.12876 1.07373 6.5506L14.5388 20.0145L1.07373 33.4784Z"
                                    fill="#F2E4B5" />
                            </svg>
                        </span>
                    </div>
                    <div class="popup-text-1" v-if="popupTexts[currentPopup]" v-html="popupTexts[currentPopup].content"></div>
                </div>
            </div>
        </transition>

        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>
</template>

<style scoped>
/* ==========================================================================
   GLOBAL BRAND VARIABLES & COMMON STYLES
   ========================================================================== */
.social-lead-page {
    width: 100%;
    overflow-x: hidden;
}

/* Links inside Conditions */
:deep(.chivas-link) {
    color: var(--color-primary-1) !important;
    font-weight: 700;
    text-decoration: underline;
    transition: color var(--transition-fast);
}

:deep(.chivas-link:hover) {
    color: var(--color-white) !important;
    text-decoration: underline;
}

/* ==========================================================================
   DESKTOP STYLES
   ========================================================================== */

/* --- First Block --- */
.first-container {
    background-image: url('../assets/img/social-lead-first-bg.jpg');
    background-size: cover;
    background-position: center;
    padding: 120px 183px 100px 183px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
}

.first-block {
    display: flex;
    flex-direction: column;
    max-width: 700px;
}

.logo-header-desktop {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.jameson-logo {
    width: 268px;
    height: auto;
    object-fit: contain;
}

.jameson-invisible {
    width: 131px;
    height: 172px;
    margin-left: 40px;
    object-fit: contain;
}

.title-first-block {
    color: var(--color-accent);
    font-weight: 700;
    font-size: 48px;
    line-height: 1.2;
    margin-top: 30px;
    font-family: var(--font-family-bold);
    text-transform: uppercase;
}

.title-first-block span {
    text-transform: uppercase;
}

.description-first-block {
    color: var(--color-white);
    font-weight: 700;
    font-size: var(--font-size-lg);
    line-height: 1.25;
    margin-top: 24px;
    max-width: 688px;
    font-family: var(--font-family-bold);
}

.description-first-block-small {
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: var(--color-white);
    line-height: 1.3;
    margin-top: 20px;
    max-width: 688px;
    font-family: var(--font-family);
}

.second-block {
    display: flex;
    justify-content: center;
    align-items: center;
}

.big-img-first-block {
    max-width: 600px;
    max-height: 837px;
    width: 100%;
    object-fit: cover;
    border-radius: var(--radius-lg);
}

/* --- Second Block (Conditions) --- */
.second-container {
    background-image: linear-gradient(180deg,
            rgba(21, 71, 52, 0.78) 0%,
            rgba(21, 71, 52, 0.78) 60%,
            rgba(21, 71, 52, 0) 94%),
        var(--bg-url);
    background-size: cover;
    background-position: center;
    padding: 80px 183px 120px;
}

.second-first-container {
    max-width: 1200px;
    margin: 0 auto;
}

.second-first-block {
    padding-top: 20px;
    margin-bottom: 40px;
}

.second-block-title {
    color: var(--color-accent);
    font-weight: 300;
    font-size: 96px;
    text-transform: uppercase;
    margin-bottom: 0;
    font-family: var(--font-family-light);
    line-height: 1;
}

.second-block-description span {
    color: var(--color-white);
    font-weight: 700;
    font-size: 32px;
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    line-height: 1.2;
    text-transform: uppercase;
    font-family: var(--font-family-bold);
}

.second-second-block {
    max-width: 1075px;
}

.condition-container {
    border-top: 2px solid var(--color-primary-1);
    padding: 24px 0;
    display: flex;
    align-items: center;
}

.second-second-block .condition-container:last-child {
    border-bottom: 2px solid var(--color-primary-1);
}

.number {
    color: var(--color-number);
    font-size: 96px;
    font-weight: 700;
    margin-bottom: 0;
    font-family: var(--font-family-bold);
    line-height: 1;
    min-width: 100px;
}

.condition-text {
    margin-bottom: 0;
    margin-left: 30px;
    font-family: var(--font-family-bold);
    line-height: 1.2;
}

.condition-text span {
    font-weight: 400;
    font-size: 32px;
    color: var(--color-white);
    font-family: var(--font-family-bold);
    text-decoration: none;
}

/* --- Third Block (Registration Form) --- */
.third-container {
    position: relative;
    background-color: var(--color-primary-1);
    min-height: 700px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 80px 20px;
    overflow: hidden;
}

.background-image-topleft {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    max-height: 100%;
    pointer-events: none;
    z-index: 1;
}

.background-image-topright {
    position: absolute;
    top: 0;
    right: 0;
    height: auto;
    max-height: 100%;
    pointer-events: none;
    z-index: 1;
}

.registration-body-container {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 540px;
    margin: 0 auto;
}

.title-container {
    margin: 0 auto 36px;
    text-align: center;
}

.text-title {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-xxl);
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary);
    margin-bottom: 0;
    line-height: 1.2;
}

.form-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 499px;
    margin: 0 auto;
}
.form-container {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.form-container > div {
    width: 100%;
}

.input-body {
    border: 1px solid var(--color-primary-btn);
    color: var(--color-primary);
    border-radius: var(--radius-md);
    padding: 14px 24px;
    width: 100%;
    height: 56px;
    font-size: var(--font-size-md);
    font-family: var(--font-family);
    background: transparent;
    box-sizing: border-box;
    outline: none;
    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.input-body::placeholder {
    color: var(--color-placeholder);
    font-size: var(--font-size-md);
    font-family: var(--font-family);
    opacity: 1;
}

.input-body:focus {
    border-color: var(--color-primary-btn);
    box-shadow: 0 0 5px rgba(0, 119, 73, 0.5);
}

/* Vuetify v-select Desktop Overrides */
.third-container ::v-deep .v-select {
    margin: 0;
    padding: 0;
    width: 100% !important;
}

.third-container ::v-deep .v-text-field--outlined fieldset {
    border-color: var(--color-primary-btn) !important;
    border-radius: var(--radius-md) !important;
}

.third-container ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: var(--color-primary-btn) !important;
}

.third-container ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 56px !important;
    height: 56px !important;
    background: transparent !important;
    padding: 0 16px !important;
    width: 100% !important;
}

.third-container ::v-deep .v-select .v-select__selection--comma,
.third-container ::v-deep .v-select .select-input,
.third-container ::v-deep .v-select .truncate-text,
.third-container ::v-deep .v-select input {
    color: var(--color-primary) !important;
    font-size: var(--font-size-md) !important;
    font-family: var(--font-family) !important;
}

.third-container ::v-deep .v-select input::placeholder {
    color: var(--color-placeholder) !important;
    font-size: var(--font-size-md) !important;
    font-family: var(--font-family) !important;
}

.third-container ::v-deep .v-select .v-icon {
    color: var(--color-primary) !important;
}

.error-message {
    color: var(--color-error);
    font-weight: 400;
    font-size: 13px;
    font-family: var(--font-family);
    min-height: 18px;
    margin-top: 4px;
    padding-left: 4px;
}

.form-loading,
.form-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 150px;
}

.form-error-text {
    font-weight: 400;
    font-size: var(--font-size-sm);
    color: var(--color-error-dark);
    margin-bottom: 0;
    font-family: var(--font-family);
    text-align: center;
}

/* Checkbox & Button */
.btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 499px;
    margin: 20px auto 0;
}

.checkbox-container {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
}

.checkbox-content {
    display: flex;
    align-items: flex-start;
    text-align: left;
}

.custom-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.checkbox-label {
    cursor: pointer;
    font-size: var(--font-size-sm);
    line-height: 1.35;
    font-family: var(--font-family);
    font-weight: 400;
    color: var(--color-primary);
    position: relative;
    padding-left: 32px;
}

.checkbox-label::before {
    content: "";
    position: absolute;
    left: 0;
    top: 2px;
    width: 22px;
    height: 22px;
    border: 1.5px solid var(--color-primary-btn);
    border-radius: 4px;
    background-color: transparent;
}

.checkbox-label::after {
    content: "";
    position: absolute;
    left: 7px;
    top: 5px;
    width: 7px;
    height: 12px;
    border: solid transparent;
    border-width: 0 2.5px 2.5px 0;
    transform: rotate(45deg);
    transition: border-color var(--transition-fast);
}

.custom-checkbox:checked + .checkbox-label::before {
    background-color: var(--color-primary-btn);
    border-color: var(--color-primary-btn);
}

.custom-checkbox:checked + .checkbox-label::after {
    border-color: var(--color-primary-1);
}

.policy-link {
    color: var(--color-primary) !important;
    text-decoration: underline !important;
    cursor: pointer;
}

.policy-link:hover {
    color: var(--color-primary-btn) !important;
}

.btn-form-submit {
    border-radius: var(--radius-md);
    padding: 12px 48px;
    height: 56px;
    width: 100%;
    max-width: 499px;
    background: var(--color-primary-btn) !important;
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-md);
    color: var(--color-primary-1) !important;
    border: none;
    cursor: pointer;
    box-shadow: var(--box-shadow-btn) !important;
    transition: all var(--transition-normal) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
}

.btn-form-submit:hover:not(:disabled) {
    background: var(--color-primary-light) !important;
    transform: translateY(-2px);
    box-shadow: var(--box-shadow-btn-hover) !important;
}

.btn-form-submit:active:not(:disabled) {
    background: var(--color-primary-dark) !important;
    transform: translateY(1px);
    box-shadow: var(--box-shadow-btn-active) !important;
}

.btn-form-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* --- Footer Block --- */
.main-container-footer {
    padding: 60px 183px;
    background-color: var(--color-primary);
}

.footer-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
}

.politics-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 250px;
}

.jameson-logo-footer {
    height: 50px;
    width: auto;
    object-fit: contain;
}

.footer-first-block {
    max-width: 450px;
    margin-right: 50px;
}

.link-text {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: var(--color-primary-1);
    margin-bottom: 0;
    line-height: 1.4;
}

.footer-second-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.footer-main-text {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: var(--font-size-sm);
    line-height: 1.6;
    color: var(--color-primary-1);
    margin-bottom: 0;
    cursor: pointer;
    text-decoration: none;
    transition: color var(--transition-fast);
}

.footer-main-text:hover {
    color: var(--color-white);
}

.social-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 240px;
    align-items: center;
}

.footer-j-logo {
    text-align: center;
}

.j-logo-footer {
    width: 118px;
    height: 155px;
    object-fit: contain;
}

.social-icons-container {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: center;
}

.social-icons-container svg {
    width: 48px;
    height: 48px;
    transition: transform var(--transition-normal);
}

.social-icons-container svg:hover {
    transform: scale(1.1);
}

/* ==========================================================================
   MOBILE STYLES (< 1264px)
   ========================================================================== */

.main-container-mobile {
    width: 100%;
}

.first-container-mobile {
    background-image: url('../assets/img/social-lead-first-bg.png');
    background-size: cover;
    background-position: center;
    padding: 30px 20px 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.first-block-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 400px;
}

.logo-container-header-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    width: 100%;
}

.jameson-logo-mobile {
    width: 168px;
    height: auto;
    object-fit: contain;
}

.banner-container-mobile {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.big-img-first-block-mobile {
    width: 100%;
    max-width: 360px;
    object-fit: cover;
    border-radius: var(--radius-sm);
}

.title-first-block-mobile {
    color: var(--color-accent);
    font-weight: 700;
    font-size: 26px;
    line-height: 1.2;
    font-family: var(--font-family-bold);
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 18px;
    padding: 0 10px;
}

.description-first-block-mobile {
    color: var(--color-white);
    font-weight: 700;
    font-size: 15px;
    line-height: 1.35;
    max-width: 360px;
    font-family: var(--font-family-bold);
    text-align: center;
    margin: 0 auto 20px;
    padding: 0 5px;
}

.description-first-block-small-mobile {
    font-weight: 400;
    font-size: 13px;
    color: var(--color-white);
    line-height: 1.35;
    max-width: 360px;
    font-family: var(--font-family);
    text-align: center;
    margin: 0 auto 20px;
    padding: 0 5px;
}

/* Mobile Second Block */
.second-container-mobile {
    padding: 40px 20px 50px;
}

.second-first-container-mobile {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}

.second-first-block-mobile {
    padding-top: 10px;
    margin-bottom: 24px;
}

.second-block-title-mobile {
    color: var(--color-accent);
    font-weight: 300;
    font-size: 32px;
    text-transform: uppercase;
    margin-bottom: 10px;
    text-align: left;
    font-family: var(--font-family-light);
}

.second-block-description-mobile span {
    font-family: var(--font-family-bold);
    color: var(--color-white);
    font-weight: 700;
    font-size: var(--font-size-sm);
    line-height: 1.3;
    text-transform: uppercase;
    text-align: left;
    display: block;
}

.second-second-block-mobile {
    width: 100%;
}

.condition-container-mobile {
    border-top: 2px solid var(--color-primary-1);
    padding: 16px 0;
    display: flex;
    align-items: center;
}

.second-second-block-mobile .condition-container-mobile:last-child {
    border-bottom: 2px solid var(--color-primary-1);
}

.number-mobile {
    color: var(--color-number);
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 0;
    font-family: var(--font-family-bold);
    line-height: 1;
    min-width: 40px;
}

.condition-text-mobile {
    margin-bottom: 0;
    margin-left: 14px;
    font-family: var(--font-family-bold);
    line-height: 1.3;
}

.condition-text-mobile span {
    font-weight: 400;
    font-size: 15px;
    color: var(--color-white);
    font-family: var(--font-family-bold);
}

/* Mobile Third Block */
.third-container-mobile {
    position: relative;
    background-color: var(--color-primary-1);
    padding: 40px 16px 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.background-image-mobile-topleft {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    object-fit: cover;
    pointer-events: none;
    z-index: 1;
}

.background-image-mobile-topright {
    position: absolute;
    top: 0;
    right: 0;
    height: auto;
    object-fit: cover;
    pointer-events: none;
    z-index: 1;
}

.registration-body-container-mobile {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
}

.text-title-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 28px;
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary);
    margin-bottom: 20px;
    line-height: 1.2;
}

.form-main-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
}

.form-container-mobile {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.form-container-mobile > div {
    width: 100%;
}

.input-body-mobile {
    border: 1px solid var(--color-primary-btn);
    border-radius: var(--radius-sm);
    padding: 12px 14px;
    width: 100%;
    max-width: 360px;
    height: 48px;
    font-size: var(--font-size-xs);
    color: var(--color-primary);
    background: transparent;
    font-family: var(--font-family);
    outline: none;
    box-sizing: border-box;
    transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.input-body-mobile::placeholder {
    color: var(--color-placeholder);
    font-size: 15px;
    font-family: var(--font-family);
    opacity: 1;
}

.input-body-mobile:focus {
    border-color: var(--color-primary-btn);
    box-shadow: 0 0 4px rgba(0, 119, 73, 0.4);
}

.third-container-mobile ::v-deep .v-select {
    margin: 0;
    padding: 0;
    width: 100% !important;
    max-width: 360px !important;
}

.third-container-mobile ::v-deep .v-text-field--outlined fieldset {
    border-color: var(--color-primary-btn) !important;
    border-radius: var(--radius-sm) !important;
}

.third-container-mobile ::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: var(--color-primary-btn) !important;
}

.third-container-mobile ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 48px !important;
    height: 48px !important;
    background: transparent !important;
    padding: 0 12px !important;
    width: 100% !important;
}

.third-container-mobile ::v-deep .v-select .v-select__selection--comma,
.third-container-mobile ::v-deep .v-select .truncate-text,
.third-container-mobile ::v-deep .v-select input {
    color: var(--color-primary) !important;
    font-size: 15px !important;
    font-family: var(--font-family) !important;
}

.third-container-mobile ::v-deep .v-select input::placeholder {
    color: var(--color-placeholder) !important;
    font-size: 15px !important;
    font-family: var(--font-family) !important;
}

.third-container-mobile ::v-deep .v-select .v-icon {
    color: var(--color-primary) !important;
}

.checkbox-container-mobile {
    width: 100%;
    display: flex;
    align-items: flex-start;
    margin-bottom: 14px;
}

.checkbox-label-mobile {
    color: var(--color-primary) !important;
    font-size: var(--font-size-xxs);
    font-weight: 400;
    line-height: 1.4;
    font-family: var(--font-family);
    position: relative;
    padding-left: 28px;
    cursor: pointer;
}

.checkbox-label-mobile::before {
    content: "";
    position: absolute;
    left: 0;
    top: 2px;
    width: 18px;
    height: 18px;
    border: 1.5px solid var(--color-primary-btn);
    border-radius: 3px;
    background-color: transparent;
}

.checkbox-label-mobile::after {
    content: "";
    position: absolute;
    left: 5px;
    top: 4px;
    width: 6px;
    height: 10px;
    border: solid transparent;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color var(--transition-fast);
}

.custom-checkbox:checked + .checkbox-label-mobile::before {
    background-color: var(--color-primary-btn);
    border-color: var(--color-primary-btn);
}

.custom-checkbox:checked + .checkbox-label-mobile::after {
    border-color: var(--color-primary-1);
}

.btn-form-submit-mobile {
    border-radius: var(--radius-sm);
    padding: 11px 32px;
    width: 100%;
    max-width: 360px;
    height: 48px;
    background: var(--color-primary-btn) !important;
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-xs);
    color: var(--color-primary-1) !important;
    border: none;
    cursor: pointer;
    box-shadow: var(--box-shadow-btn) !important;
    transition: all var(--transition-normal) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 12px auto 0;
}

.btn-form-submit-mobile:hover:not(:disabled) {
    background: var(--color-primary-light) !important;
}

.btn-form-submit-mobile:active:not(:disabled) {
    background: var(--color-primary-dark) !important;
}

.btn-form-submit-mobile:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Mobile Footer Block */
.main-container-footer-mobile {
    padding: 40px 16px 50px;
    background-color: var(--color-primary);
}

.footer-container-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.politics-container-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.logo-container-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    width: 100%;
}

.jameson-logo-footer-mobile {
    height: 44px;
    width: auto;
    object-fit: contain;
}

.logo-container-footer-2 {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0;
    width: 100%;
}

.j-logo-footer-mobile {
    width: 90px;
    height: 118px;
    object-fit: contain;
}

.link-text-mobile {
    font-weight: 400;
    font-size: var(--font-size-xxs);
    color: var(--color-primary-1);
    margin-bottom: 0;
    font-family: var(--font-family);
    line-height: 1.4;
    text-align: center;
}

.footer-second-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-top: 16px;
}

.footer-main-text-mobile {
    font-family: var(--font-family);
    font-weight: 400;
    font-size: 15px;
    line-height: 1.5;
    color: var(--color-primary-1);
    margin-bottom: 0;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
}

.social-container-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

/* ==========================================================================
   POPUPS & SNACKBAR
   ========================================================================== */

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    padding: 20px;
}

.popup-content {
    background-color: var(--color-primary-popup);
    border: 1px solid rgba(242, 228, 181, 0.3);
    padding: 30px;
    width: 100%;
    max-width: 1000px;
    border-radius: var(--radius-md);
    height: 100%;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.popup-header {
    padding-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(242, 228, 181, 0.2);
}

.header-text {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 22px;
    text-transform: uppercase;
    color: var(--color-primary-1);
}

.popup-close-1 {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.popup-close-1 svg {
    transition: transform var(--transition-fast);
}

.popup-close-1:hover svg {
    transform: scale(1.15);
}

.popup-text-1 {
    font-family: var(--font-family-legal);
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: var(--color-primary-1);
    line-height: 1.6;
    white-space: pre-line;
    padding: 20px 10px 0 0;
    overflow-y: auto;
    flex: 1;
}

.popup-text-1::-webkit-scrollbar {
    width: 6px;
}

.popup-text-1::-webkit-scrollbar-thumb {
    background-color: var(--color-primary-1);
    border-radius: 4px;
}

.popup-text-1::-webkit-scrollbar-track {
    background: rgba(242, 228, 181, 0.1);
    border-radius: 4px;
}

.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes fadeOut {
    from { opacity: 0; }
    to { opacity: 0; }
}

@keyframes slideIn {
    from { transform: translateY(-20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
}

@keyframes slideOut {
    from { transform: translateY(0); opacity: 1; }
    to { transform: translateY(-20px); opacity: 0; }
}

.snackbar-btn {
    color: var(--color-error);
    font-family: var(--font-family);
    font-size: var(--font-size-xxs);
    font-weight: 400;
    padding: 12px 16px;
    cursor: pointer;
}

@media screen and (max-width: 768px) {
    .header-text {
        font-size: var(--font-size-sm);
    }

    .popup-text-1 {
        font-size: var(--font-size-xxs);
    }
}
</style>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import Otp from '@/components/otp.vue';
import ConfirmAge1 from "@/components/age-confirm.vue";
import config from "@/config/pageConfig.json";
import {
    initLanding,
    trackFormStart,
    trackFormSubmit,
    trackFormError,
    trackRegistrationSuccess,
    trackVirtualPageView
} from '@/utils/analytics';

export default {
    directives: { mask },
    name: "SocialLead",
    components: {
        Otp,
        ConfirmAge1
    },
    data() {
        return {
            campaignId: "4b6676d5-f999-f011-b7ff-00155d79212a",
            showConfirm: true,
            isMobile: window.innerWidth < 1264,
            showOtpPopup: false,
            snackbar: false,
            message: "",
            smsTimer: 60,
            smsTimerInterval: null,
            isSendSms: false,
            isPopupOpen: false,
            currentPopup: null,
            formSchema: null,
            otpSuccess: false,
            otpVerifying: false,
            isLoadingForm: true,
            formError: false,
            otpError: "",
            otpErrorSms: false,
            formData: {},
            errors: {},
            touched: {},
            popupTexts: {
                policy: {
                    title: "Политика конфиденциальности",
                    content: `<b>Pernod Ricard Kazakhstan,</b> в качестве оператора персональных данных, уважает ваше
право на конфиденциальность при использовании веб-сайта
Цель настоящей Политики конфиденциальности — информировать вас о том, каким
образом компания Pernod Ricard Kazakhstan собирает, хранит, использует и обрабатывает
ваши персональные данные, предоставленные через веб-сайт (далее «Веб-сайт»).
Темы:
1. Какие персональные данные мы собираем?
2. Как и зачем мы используем технологии отслеживания?
3. С какой целью мы используем ваши персональные данные и на каком правовом
основании?
4. Что произойдет, если вы откажетесь предоставить свои персональные данные?
5. Кому мы раскрываем ваши персональные данные и почему?
6. Передаются ли ваши персональные данные за пределы Казахстана?
7. Как долго мы храним ваши персональные данные?
8. Как мы обеспечиваем защиту ваших персональных данных?
9. Каковы ваши права в отношении ваших персональных данных?
10. Как с нами связаться или подать жалобу в надзорный орган?
11. Изменения в Политике конфиденциальности

<b>1. Какие персональные данные мы собираем?</b>
Мы собираем следующие персональные данные:
- Имя, фамилия
- Дата рождения
- Адрес электронной почты
- Пароль
- Должность
- Название места работы
- Фотография
- IP-адрес
- Интересы
<b>Примечание:</b> IP-адрес — это последовательность чисел, используемая для
идентификации вашего устройства при каждом подключении к интернету.

<b>2. Как и зачем мы используем технологии отслеживания?</b>
С вашего согласия, если это требуется по закону, наш Веб-сайт использует файлы cookie и
подобные технологии отслеживания, такие как IP-адреса или журналы. Эти технологии
помогают нам:
- Лучше понимать, как посетители используют наш Веб-сайт и его функции.
- Улучшать их функциональность.
- Предоставлять контент, соответствующий вашим интересам.

<b>Подробнее о cookies:</b> см. Политику использования файлов cookie.

<b>3. С какой целью мы используем ваши персональные данные и на каком правовом основании?</b>
<b>Pernod Ricard Kazakhstan</b> обрабатывает ваши данные в следующих целях:
- Предоставление доступа к Веб-сайту и создание профиля пользователя.
- Обеспечение доступа к функциям сайта (например, доступ к онлайн-контенту,
участие в тренингах, регистрация на мероприятия).
- Отправка административных уведомлений и сервисных сообщений.
Мы также можем адаптировать наш контент в зависимости от ваших интересов для
улучшения вашего опыта на сайте.
При наличии вашего согласия данные могут использоваться для отправки маркетинговых
сообщений.

<b>4. Что произойдет, если вы откажетесь предоставить свои персональные данные?</b>
Если вы решите не предоставлять запрашиваемые данные, вы не сможете:
- Участвовать в некоторых активностях.
- Пользоваться персонализированными функциями.
- Получать специальные услуги.
<b>Пример:</b> без адреса электронной почты вы не сможете получать наши рассылки. Однако
вы можете просматривать сайт без предоставления данных.

<b>5. Кому мы раскрываем ваши персональные данные и почему?</b>
<b>В рамках группы Pernod Ricard</b>
Ваши данные могут быть переданы аффилированным компаниям группы Pernod Ricard.
<b>Третьи стороны</b>
Ваши данные могут быть переданы третьим сторонам в следующих случаях:
- <b>Техническая поддержка:</b> провайдеры, агенты или подрядчики.
- <b>Организация мероприятий и тренингов.</b>
- <b>По закону:</b> для защиты прав и безопасности компании или общества.
- <b>Слияние или поглощение:</b> передача данных новому владельцу в соответствии с
законом.

<b>6. Передаются ли ваши персональные данные за пределы Казахстана?</b>
Данные могут передаваться за границу с соблюдением всех необходимых мер защиты,
включая стандартные договорные положения Европейской комиссии.

<b>7. Как долго мы храним ваши персональные данные?</b>
Данные хранятся:
- Пока ваш аккаунт активен.
- Пока это необходимо для предоставления функций сайта.
Также данные могут храниться для выполнения правовых обязательств.

<b>8. Как мы обеспечиваем защиту ваших персональных данных?</b>
<b>Pernod Ricard Kazakhstan</b> принимает все необходимые меры для защиты ваших данных,
включая:
- Хранение данных в защищенных операционных средах.
- Доступ к данным только у уполномоченных сотрудников и подрядчиков.

<b>9. Каковы ваши права в отношении ваших персональных данных?</b>
Вы имеете право:
- Отозвать согласие на обработку данных.
- Запросить доступ, исправление или удаление данных.
- Ограничить обработку или запросить перенос данных.
- Возражать против обработки.

<b>10. Как с нами связаться или подать жалобу в надзорный орган?</b>
По вопросам и жалобам, связанным с Политикой конфиденциальности, обращайтесь по
адресу:
<b>Алматы, Казахстан, Рубинштейна, 48, 050060</b>

Или по электронной почте: <b>promo.kz@pernod-ricard.com.</b>

<b>11. Изменения в Политике конфиденциальности</b>
Мы регулярно обновляем нашу Политику конфиденциальности и размещаем изменения
на этой странице.
<b>Дата последнего обновления:</b> ноябрь 2024 года.`,
                },
                offer: {
                    title: "СОГЛАСИЕ НА СБОР И ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ",
                    content: `Я подтверждаю, что достиг возраста 21 года и более и даю <b>ТОО «Перно Рикар
Казахстан», (БИН 050840001045),</b> а также их работникам и третьим лицам-соисполнителям по
заключенным между ними договорам, <b>свое согласие</b> на сбор, обработку,
распространение и трансграничную передачу (без дополнительных уведомлений)
моих персональных данных, относящихся исключительно к перечисленным ниже
категориям персональных данных:
 1) ФИО
 2) Город проживания
 3) Мобильный телефон
 4) E-mail
<b>Согласованная цель сбора и обработки персональных данных</b> – пополнение CRM
базы посредством предоставления персональных данных любыми средствами связи
для участия в активностях, проводимых в отношении товарных знаков продукции
ТОО «Перно Рикар Казахстан».
Я даю согласие на использование персональных данных исключительно в
вышеуказанных целях, а также на обработку персональных данных и их
трансграничную передачу на всех электронных носителях, используемых для
вышеуказанной цели.
Настоящее согласие предоставляется мной на осуществление действий в отношении
моих персональных данных, которые необходимы для достижения указанных выше
целей, включая (без ограничения) сбор, систематизацию, накопление, хранение,
точнение (обновление, изменение), использование, передачу третьим лицам для
осуществления действий по обмену информацией, обезличивание, блокирование
персональных данных, трансграничную передачу персональных данных на территорию любого государства, в том числе не обеспечивающего защиту персональных данных, распространение моих персональных данных в общедоступных источниках,
а также осуществление любых иных действий,
предусмотренных действующим законодательством Республики Казахстан.
Я предоставляю согласие на контактирование со мной для вышеуказанных целей путем осуществления разговора, телефонных звонков, направления мне уведомлений с использованием почты, телефона (также SMS), социальных сетей и/или мессенджеров, вебсайтов, электронной почты, электронных информационных ресурсов и иных информационных систем и мобильных приложений. 
Я проинформирован, что вышеуказанные компании гарантируют обработку моих
персональных данных в соответствии с действующим законодательством Республики
Казахстан как неавтоматизированным, так и автоматизированным способами.
Данное согласие действует в течение срока хранения информации в вышеуказанных
целях.
Данное согласие может быть отозвано в любой момент по моему письменному заявлению, отправленному в адрес Компании по ее юридическому адресу, зарегистрированному на дату отправки заявления или посредством направления электронного сообщения на электронную почту Компании: promo.kz@pernod-ricard.com. В случае отзыва настоящего согласия все мои Персональные данные подлежат уничтожению из базы данных Компании. 
Я подтверждаю, что для включения моих персональных данных в базу данных, в том числе партнеров указанных компаний, передачи, распространения, дополнения и прочей обработки моих персональных данных указанными компаниями с вышеупомянутой целью не требуется дополнительного уведомления меня о совершении данных действий. 

Я подтверждаю, что, давая настоящее согласие, я действую по собственной воле, в своих интересах и полностью осознаю суть и цели подписываемого документа.`,
                },
                rules: {
                    title: "Полные правила активности",
                    content: `<b>1. Общие положения</b>

1.1. Активация не является лотереей, азартной игрой или иным мероприятием,
регулируемым Законом Республики Казахстан от 9 апреля 2016 года № 495-V «О лотереях
и лотерейной деятельности».
1.2. Участие в активации является добровольным и означает полное и безусловное
согласие участника с настоящими Правилами.
1.3. Пул предоставляемых возможностей формируется за счёт средств Организатора.

<b>2. Условия участия</b>

2.1. К участию допускаются только физические лица, достигшие 21 года на момент
участия, постоянно проживающие на территории Республики Казахстан, не являющиеся
сотрудниками Организатора, а также сотрудниками подрядных организаций, причастных к
проведению активации, и их близкими родственниками.
2.2. Принимая участие в активации, участник подтверждает, что настоящие Правила им
прочитаны и понятны, и что участник безоговорочно и в полном объеме соглашается с
ними, без каких-либо ограничений и исключений.
2.3. Для участия участнику необходимо:
2.3.1. подписаться на официальный аккаунт @jamesonkz в социальной сети Instagram;
2.3.2. сделать репост конкурсной публикации в сторис;
2.3.3. пройти регистрацию на официальном сайте Организатора.
2.4. Один пользователь Instagram может участвовать только единожды, с одного личного
аккаунта.

<b>3. Порядок определения победителей</b>

3.1. По завершении периода проведения Активации Организатор в случайном порядке
определяет победителей среди участников, выполнивших все условия.
3.2. Победители будут уведомлены Организатором через контактные данные, указанные при регистрации.

<b>4. Ограничения и ответственность</b>

4.1. Организатор не несёт ответственности за невозможность участия в Активации по причинам,
не зависящим от Организатора.
4.2. Организатор оставляет за собой право отказать в учёте участия или аннулировать
результат при выявлении фактов нарушения участником настоящих Правил.

<b>5. Заключительные положения</b>

5.1. Факт участия в активации означает ознакомление и полное согласие участника с
настоящими Правилами.`,
                }
            },
            config: {
                ...config,
            }
        };
    },
    created() {
        if (localStorage.getItem("userAge") !== null) {
            this.showConfirm = false;
        }
    },
    computed: {
        ...mapGetters(['getUserAge']),
        filteredQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type === 11 || q.type === 12));
        },
        normalQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type !== 11 && q.type !== 3 && q.type !== 12));
        }
    },
    beforeDestroy() {
        if (this.smsTimerInterval) {
            clearInterval(this.smsTimerInterval);
        }
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        initLanding({
            brand: 'jameson',
            activation: 'jameson_merch_2026',
            landing_id: 'jameson-merch-2026',
            landing_type: 'registration'
        });
        this.getFormFields();
    },
    watch: {
        formData: {
            deep: true,
            handler() {
                if (!this.formSchema?.questions) return;
                for (let question of this.formSchema.questions) {
                    if (this.touched[question.id]) {
                        this.validateField(question);
                    }
                }
            }
        },
        getUserAge(newVal) {
            if (!newVal || !this.formSchema?.questions) return;
            const birthQuestion = this.formSchema.questions.find(q => q.type === 3);
            if (birthQuestion) {
                this.$set(this.formData, birthQuestion.id, newVal);
            }
        }
    },
    methods: {
        onConfirmed() {
            this.showConfirm = false;
        },
        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        validateField(question) {
            const value = this.formData[question.id];
            let error = null;

            if ([1, 2, 4, 5, 7, 10].includes(question.type)) {
                if (value === undefined || value === null || String(value).trim() === "") {
                    error = "Поле обязательно";
                }
            }
            if (question.type === 11 || question.type === 12) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if (error === null) {
                if (question.type === 1) {
                    if (!/^[А-Яа-яA-Za-z\s]+$/.test(value)) {
                        error = "Введите корректное имя.";
                    }
                }
                if (question.type === 2) {
                    if (!/^[А-Яа-яA-Za-z\s]+$/.test(value)) {
                        error = "Введите корректную фамилию.";
                    }
                }
                if (question.type === 7) {
                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                        error = "Введите корректный email.";
                    }
                }
                if (question.type === 4) {
                    if (!/^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value)) {
                        error = "Введите корректный номер телефона.";
                    }
                }
            }

            this.$set(this.errors, question.id, error);
        },
        markTouched(question) {
            this.$set(this.touched, question.id, true);
            this.validateField(question);
        },
        getPlaceholder(question, isMobile = false) {
            switch (question.type) {
                case 5:
                    return "Город";
                case 9:
                    return isMobile ? "Какой Jameson вы предпочитаете?" : "Продукт";
                case 10:
                    return isMobile ? "Ваш логин в Instagram" : "Введите логин";
                default:
                    return question.name;
            }
        },
        getFormFields() {
            this.isLoadingForm = true;
            this.formError = false;
            this.$http.get('/api/survey', {
                params: {
                    campaignId: this.campaignId
                }
            })
                .then(res => {
                    this.formSchema = res.data;
                    res.data.questions.forEach(q => {
                        if (q.type === 3) {
                            this.$set(this.formData, q.id, this.getUserAge || "");
                        } else {
                            this.$set(this.formData, q.id, "");
                        }
                    });
                })
                .catch(err => {
                    this.formError = true;
                    console.error("Ошибка загрузки формы", err);
                })
                .finally(() => {
                    this.isLoadingForm = false;
                });
        },
        openPopup(type) {
            this.currentPopup = type;
            this.isPopupOpen = true;
        },
        goTo(url) {
            window.open(url, '_blank');
        },
        async sendVerificationCode() {
            const phoneQuestion = this.formSchema?.questions?.find(q => q.type === 4);
            if (!phoneQuestion) return false;

            const phoneAnswerRaw = this.formData[phoneQuestion.id];
            if (!phoneAnswerRaw) return false;
            const phoneAnswer = phoneAnswerRaw.replace(/[^\d+]/g, "");

            try {
                this.isSendSms = true;
                await this.$recaptchaLoaded();
                const recaptchaToken = await this.$recaptcha('send_sms');

                const answerDto = {
                    campaignId: "4b6676d5-f999-f011-b7ff-00155d79212a",
                    surveyAnswer: {
                        surveyQuestionId: phoneQuestion.id,
                        answer: phoneAnswer
                    },
                    recaptchaToken: recaptchaToken,
                };
                console.log("Token:", recaptchaToken);
                console.log(answerDto);

                await this.$http.post("/api/Verification/SendCode", answerDto);
                console.log("Код отправлен!");
                this.otpErrorSms = false;
                return true;
            } catch (err) {
                console.error("Ошибка при отправке кода:", err);
                if (err?.response?.status === 409) {
                    this.otpErrorSms = true;
                    this.showOtpPopup = true;
                    this.otpSuccess = false;
                    return false;
                }
                if (err?.response?.status === 403) {
                    this.snackbar = true;
                    this.message = 'Подозрение на бота. Попробуйте перезагрузить страницу.';
                    return false;
                }
                this.snackbar = true;
                this.message = 'Ошибка при отправке кода. Попробуйте снова.';
                return false;
            } finally {
                this.isSendSms = false;
            }
        },
        async resendSms() {
            await this.startSmsTimer();
            await this.sendVerificationCode();
        },
        async confirmRegistration() {
            trackFormSubmit('main_registration');
            this.otpError = "";
            if (!this.formSchema) return;

            this.formSchema.questions.forEach(q => {
                this.markTouched(q);
            });

            let hasErrors = false;
            if (this.formSchema?.questions) {
                this.formSchema.questions.forEach(q => {
                    const val = this.formData[q.id];
                    const err = this.errors[q.id];

                    let fieldName = 'field_' + q.id;
                    switch (q.type) {
                        case 1: fieldName = 'name'; break;
                        case 2: fieldName = 'surname'; break;
                        case 3: fieldName = 'birth_date'; break;
                        case 4: fieldName = 'phone'; break;
                        case 5: fieldName = 'city'; break;
                        case 7: fieldName = 'email'; break;
                        case 9: fieldName = 'product_choice'; break;
                        case 10: fieldName = 'instagram'; break;
                        case 11: fieldName = 'consent_personal_data'; break;
                        case 12: fieldName = 'consent_rules'; break;
                    }

                    const isEmpty = val === null || val === undefined || val === '' || ((q.type === 11 || q.type === 12) && val === false);

                    if (err || isEmpty) {
                        hasErrors = true;
                        let code = 'validation_error';
                        if (isEmpty) {
                            code = (q.type === 11 || q.type === 12) ? 'consent_required' : `${fieldName}_empty`;
                        } else if (q.type === 4) {
                            code = 'phone_invalid_format';
                        } else if (q.type === 7) {
                            code = 'email_invalid_format';
                        } else if (q.type === 1 || q.type === 2) {
                            code = `${fieldName}_invalid_format`;
                        }
                        trackFormError({
                            formId: 'main_registration',
                            errorType: 'validation',
                            fieldName,
                            errorTextCode: code
                        });
                    }
                });
            }

            if (hasErrors) {
                this.snackbar = true;
                this.message = 'Пожалуйста, заполните все обязательные поля корректно';
                return;
            }

            try {
                this.isSendSms = true;
                const isSent = await this.sendVerificationCode();
                if (isSent && !this.otpErrorSms) {
                    this.otpError = "";
                    this.otpSuccess = false;
                    this.showOtpPopup = true;
                    this.startSmsTimer();
                }
            } catch {
                this.snackbar = true;
                this.message = 'Ошибка при отправке кода. Попробуйте снова.';
            } finally {
                this.isSendSms = false;
            }
        },
        async submitAnswersWithCode(code) {
            this.otpVerifying = true;
            this.otpError = "";
            this.otpSuccess = false;
            try {
                const payload = {
                    surveyId: this.formSchema.id,
                    campaignId: "4b6676d5-f999-f011-b7ff-00155d79212a",
                    verificationCode: code,
                    answers: Object.entries(this.formData).map(([key, value]) => {
                        let answer = String(value);
                        if (/^\+7[\d\s()-]{10,}$/.test(answer)) {
                            answer = answer.replace(/[^\d+]/g, '');
                        }
                        return {
                            surveyQuestionId: key,
                            answer
                        };
                    })
                };

                await this.$http.post('/api/AnswerSet', payload);
                this.otpSuccess = true;

                // Track successful registration and virtual page view
                const cityQuestion = this.formSchema?.questions?.find(q => q.type === 5);
                const productQuestion = this.formSchema?.questions?.find(q => q.type === 9);

                let cityName = '';
                if (cityQuestion && this.formData[cityQuestion.id]) {
                    const ans = (cityQuestion.answers || []).find(a => a.id === this.formData[cityQuestion.id]);
                    cityName = ans ? ans.name : String(this.formData[cityQuestion.id]);
                }

                let productName = '';
                if (productQuestion && this.formData[productQuestion.id]) {
                    const ans = (productQuestion.answers || []).find(a => a.id === this.formData[productQuestion.id]);
                    productName = ans ? ans.name : String(this.formData[productQuestion.id]);
                }

                trackRegistrationSuccess({
                    formId: 'main_registration',
                    city: cityName,
                    productChoice: productName
                });

                trackVirtualPageView('/jameson/thank-you', 'Спасибо за регистрацию');

                this.resetForm();
            } catch (error) {
                console.error(error);
                const msg = error?.response?.data?.message || "Код введён неверно";
                this.otpError = msg;
                trackFormError({
                    formId: 'main_registration',
                    errorType: 'server',
                    fieldName: 'otp_code',
                    errorTextCode: 'otp_invalid_code'
                });
            } finally {
                this.otpVerifying = false;
            }
        },
        resetForm() {
            if (this.formSchema && this.formSchema.questions) {
                this.formSchema.questions.forEach(q => {
                    if (q.type === 3) {
                        this.$set(this.formData, q.id, this.getUserAge);
                    } else {
                        this.$set(this.formData, q.id, "");
                    }
                });
            }
            this.errors = {};
            this.touched = {};
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        startSmsTimer() {
            this.smsTimer = 60;
            if (this.smsTimerInterval) clearInterval(this.smsTimerInterval);
            this.smsTimerInterval = setInterval(() => {
                if (this.smsTimer > 0) {
                    this.smsTimer--;
                } else {
                    clearInterval(this.smsTimerInterval);
                    this.smsTimerInterval = null;
                }
            }, 1000);
        },
        onPhoneFocus(question) {
            trackFormStart('main_registration');
            if (!this.formData[question.id]) {
                this.$set(this.formData, question.id, '+7');
            }
        },
        onPhoneInput(question) {
            const val = this.formData[question.id] || '';
            if (!val.startsWith('+7')) {
                this.formData[question.id] = '+7' + val.replace(/\D/g, '').slice(1);
            }
            this.validateField(question);
        },
        closePopup() {
            this.showPopup = false;
            this.isPopupOpen = false;
            this.phone = '';
            this.email = '';
            this.name = '';
            this.city = '';
            this.surname = '';
            this.checkbox = false;
        },
    }
}
</script>